import PersonaControlStore from './schema/PersonaControlStore';
import PersonaControlViewState from './schema/PersonaControlViewState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import '../orchestrators/fetchPersonaPhotoOrchestrator';

const initialPersonaControlStore: PersonaControlStore = {
    viewStates: new ObservableMap<string, PersonaControlViewState>({}),
};
export const getStore = createStore<PersonaControlStore>(
    'personacontrol',
    initialPersonaControlStore
);

export default getStore();
